import "./GroupPopup.css";

import React, { useState } from "react";

import { Button } from "@mui/material";
import StorageLimitReachedPopup from "Components/Popup/StorageLimitReachedPopup/StorageLimitReachedPopup";
import blank from "Media/blank-profile-picture.png";
import { toast } from "react-toastify";
import useIsStorageLimitReached from "Hooks/useIsStorageLimitReached";

const GroupPopup = ({ setGroupPopup, data, verify, update }) => {
  const isStorageLimitReached = useIsStorageLimitReached();

  const [groupName, setGroupName] = useState("");
  const [listItem, setListItem] = useState([]);
  const [removeItem, setRemoveItem] = useState([]);
  const [imageData, setImageData] = useState(null);
  const [showStorageLimitReachedPopup, setShowStorageLimitReachedPopup] =
    useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isStorageLimitReached(imageData?.size))
      return setShowStorageLimitReachedPopup(true);
    console.log({listItem, removeItem, groupName, imageData ,data})
    if (data[0]?.connected) {
     if (
  listItem.length > 0 ||
  removeItem.length > 0 ||
  groupName !== "" ||
  imageData
) {
        update(listItem, removeItem, groupName, imageData);
        setTimeout(() => {
          setGroupPopup(false);
        }, 1000);
      } else {
        toast("Select at least one person", {
          type: "info",
        });
      }
    } else {
    if (listItem.length > 0) {
        verify(listItem, imageData, groupName);
        setTimeout(() => {
          setGroupPopup(false);
        }, 1000);
      } else {
        toast("Select at least one person", {
          type: "info",
        });
      }
    }
  };

const handleInput = (e) => {
  const { name, checked } = e.target;

  setListItem((prev) => {
    if (checked) {
      // add user if not already present
      if (prev.includes(name)) return prev;
      return [...prev, name];
    } else {
      // remove user
      return prev.filter((item) => item !== name);
    }
  });
};

const handleRemoveInput = (e) => {
  const { name, checked } = e.target;

  setRemoveItem((prev) => {
    if (checked) {
      if (prev.includes(name)) return prev;
      return [...prev, name];
    } else {
      return prev.filter((item) => item !== name);
    }
  });
};

  return (
    <>
      <nav className="group-popup-container">
        <div className="group-popup-popup">
          <div className="group-together">
            <span className="title">
              {data[0]?.connected ? "Update Group:" : "Create a group:"}
            </span>
            <div
              className="group-popup-cross"
              onClick={() => setGroupPopup(false)}
            >
              X
            </div>
          </div>

          {Object.keys(data).length?.toString() !== "0" ? (
            <form
              onSubmit={handleSubmit}
              className="group-popup-organization"
              autoComplete="off"
            >
              {data[0].connected ? (
                <div className="group-popup-name">
  <label htmlFor="group-name">
    <span>Update Name:</span>

    <input
      type="text"
      id="group-name"
      value={groupName}
      onChange={(e) => setGroupName(e.target.value)}
    />
  </label>
</div>
              ) : (
                <div className="group-popup-name">
  <label htmlFor="group-name">
    <span>Group Name:</span>

    <input
      type="text"
      id="group-name"
      value={groupName}
      onChange={(e) => setGroupName(e.target.value)}
      required
    />
  </label>
</div>
              )}

              {data[0]?.connected ? (
                <label className="group-popup-image" htmlFor="group-image">
                  <span>Update Logo:</span>
                  <input
                    type="file"
                    id="group-image"
                    onChange={(e) => {
                      const size = e.target.files[0]?.size;
                      if (size > 10000000) {
                        toast("File size excceded 10MB", {
                          type: "info",
                        });
                      } else {
                        setImageData(e.target.files[0]);
                      }
                    }}
                  />
                </label>
              ) : (
                <label className="group-popup-image" htmlFor="group-image">
                  <span>Group Logo:</span>
                  <input
                    type="file"
                    id="group-image"
                    onChange={(e) => {
                      const size = e.target.files[0]?.size;
                      if (size > 10000000) {
                        toast("File size excceded 10MB", {
                          type: "info",
                        });
                      } else {
                        setImageData(e.target.files[0]);
                      }
                    }}
                  />
                </label>
              )}

              {/* if group is already created then it will go to first condition */}
              {data[0].connected ? (
                <>
                  <h3>Remove Candidates:</h3>
                  <div className="group-popup-connected">
                    {data[0].connected
                      ? data[0].connected?.map((curr, index) => {
                          return (
                            <label
                              className="group-popup-checkbox"
                              key={index}
                              htmlFor={curr?.id}
                              onChange={(e) => {
                                handleRemoveInput(e);
                              }}
                            >
                              <input
                                type="checkbox"
                                name={curr?.id}
                                id={curr?.id}
                                value={curr?.id}
                              />

                              <img
                                src={curr?.image || blank}
                                alt="logo"
                                onError={(e) => {
                                  e.target.onerror = null; // Prevent infinite loop
                                  e.target.src = blank; // Fallback to demo image
                                }}
                              />
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "flex-start",
                                  justifyContent: "flex-start",
                                }}
                              >
                                <span>
                                  {curr?.username ? curr?.username : "No name"}
                                </span>
                                <span
                                  style={{ fontSize: "12px", color: "#777" }}
                                >
                                  {curr?.organization_name}
                                </span>
                              </div>
                            </label>
                          );
                        })
                      : null}
                  </div>

                  {/* new members to add */}
                  <h3>Add Candidates:</h3>
                  <div className="group-popup-disconnected">
                    {data[1].disconnected
                      ? data[1].disconnected?.map((curr, index) => {
                          return (
                            <label
                              className="group-popup-checkbox"
                              key={index}
                              htmlFor={curr?.id}
                              onChange={(e) => {
                                handleInput(e);
                              }}
                            >
                              <input
                                type="checkbox"
                                name={curr?.id}
                                id={curr?.id}
                                value={curr?.id}
                              />

                              <img
                                src={curr?.image || blank}
                                alt="logo"
                                onError={(e) => {
                                  e.target.onerror = null; // Prevent infinite loop
                                  e.target.src = blank; // Fallback to demo image
                                }}
                              />
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "flex-start",
                                  justifyContent: "flex-start",
                                }}
                              >
                                <span>
                                  {curr?.username ? curr?.username : "No name"}
                                </span>
                                <span
                                  style={{ fontSize: "11px", color: "#777" }}
                                >
                                  {curr?.organization_name}
                                </span>
                              </div>
                            </label>
                          );
                        })
                      : null}
                  </div>
                </>
              ) : (
                <>
                  <div className="group-popup-list">
                    {data?.map((curr, index) => {
                      return (
                        <label
                          className="group-popup-checkbox"
                          key={index}
                          htmlFor={curr?.id}
                          onChange={(e) => {
                            handleInput(e);
                          }}
                        >
                          <input
                            type="checkbox"
                            name={curr?.id}
                            id={curr?.id}
                            value={curr?.id}
                          />

                          <img
                            src={curr?.image || blank}
                            alt="logo"
                            onError={(e) => {
                              e.target.onerror = null; // Prevent infinite loop
                              e.target.src = blank; // Fallback to demo image
                            }}
                          />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                              justifyContent: "flex-start",
                            }}
                          >
                            <span>{curr?.name ? curr?.name : "No name"}</span>
                            <span style={{ fontSize: "12px", color: "#777" }}>
                              {curr?.organization_name}
                            </span>
                          </div>
                        </label>
                      );
                    })}
                  </div>
                </>
              )}

              <Button variant="contained" type="submit">
                Submit
              </Button>
            </form>
          ) : null}
        </div>
      </nav>
      <div style={{ position: "absolute", left: 0 }}>
        {showStorageLimitReachedPopup && (
          <StorageLimitReachedPopup hide={setShowStorageLimitReachedPopup} />
        )}
      </div>
    </>
  );
};

export default GroupPopup;
